// auth.service.ts
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from "@angular/common/http";
import { environment } from "src/envs/environnement";
import { Observable } from "rxjs";
import { jwtDecode } from "jwt-decode";

@Injectable({
  providedIn: 'root',
})
export class GeneralService {
  private baseUrl = environment.baseUrl; // Remplace avec ton URL backend
  public endpoints = "personnel"
  constructor(private http: HttpClient) { }

  getList(endpoint: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/${endpoint}`);
  }

  getPlanning(idStructure: string, start: string, end: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/maintenances/planning/${idStructure}?start=${start}&end=${end}`);
  }

  getStringList(endpoint: string): Observable<any[]> {
    return this.http.get<any>(`${this.baseUrl}/${endpoint}`);
  }

  //

  annulerReservation(endpoint: string, id: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}/${endpoint}/${id}`);
  }



  donwload(filename: string): Observable<Blob> {
    return this.http.get<Blob>(`${this.baseUrl}/files/download/${filename}`, { responseType: 'blob' as 'json' });
  }

  donwloadQR(idEquipement: string): Observable<Blob> {
    return this.http.get<Blob>(`${this.baseUrl}/pdf-generator/get-qrcode/${idEquipement}`, { responseType: 'blob' as 'json' });
  }





  getListByStatus(endpoint: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/${endpoint}`);
  }


  getListTodayNonRealise(endpoint: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/${endpoint}`);
  }


  getEquipementListByStatus(endpoint: string, statut: string, id: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/${endpoint}/${statut}/${id}`);
  }

  getById(endpoint: string, id: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/${endpoint}/${id}`);
  }

  getFile(endpoint: string, id: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/${endpoint}/${id}`, { responseType: 'blob' });
  }


  getNextRef(endpoint: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/${endpoint}`);
  }

  create(endpoint: string, data: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/${endpoint}`, data);
  }

  upload(endpoint: string, data: FormData): Observable<string> {
    return this.http.post(`${this.baseUrl}/${endpoint}`, data, { responseType: 'text' });
  }

  update(endpoint: string, id: string, data: any): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}/${endpoint}/${id}`, data);
  }

  updatebyId(endpoint: string, id: string, data: any): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}/${endpoint}`, data);
  }

  delete(endpoint: string, id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${endpoint}/${id}`);
  }
}
